import { Avatar, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { ArrowBackBlue } from 'Images';
import { onEnterOrEscapeKeyDown } from 'Utils/accessibilityOnKeyDown';

interface IOpenClose {
  isOpen: boolean;
  setIsOpen: Function;
  hasDetailsData?: boolean;
}

export const OpenClose = ({
  isOpen,
  setIsOpen,
  hasDetailsData,
}: IOpenClose) => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Suppliers).resultPage;
  const isDesktop = useIsDesktop();

  return (
    <Stack
      direction='row'
      alignItems='center'
      justifyContent={isDesktop ? 'flex-end' : 'center'}
      gap='4px'
      sx={{
        mt: isDesktop ? '-20px' : '24px',
        mr: isDesktop ? '-15px' : undefined,
        minWidth: '150px',
        width: isDesktop ? 'fit-content' : undefined,
        height: 'fit-content',
        p: isDesktop ? '20px 15px' : undefined,

        ':hover': {
          cursor: hasDetailsData ? 'pointer' : 'default',
          textDecoration: 'underline',
        },
      }}
      onClick={() => (hasDetailsData ? setIsOpen(!isOpen) : undefined)}
      onKeyDown={onEnterOrEscapeKeyDown}
      tabIndex={hasDetailsData ? 0 : 1}
      role={hasDetailsData ? 'button' : undefined}
      aria-expanded={isOpen}
    >
      {hasDetailsData && (
        <>
          <Typography
            variant='body3'
            sx={{
              color: 'primary.main',
              whiteSpace: 'nowrap',
            }}
          >
            {isOpen ? dictionary.close : dictionary.moreInfo}
          </Typography>
          <Avatar
            alt=''
            src={ArrowBackBlue}
            sx={{
              width: '16px',
              height: '16px',
              transform: isOpen ? 'rotate(90deg)' : 'rotate(-90deg)',
            }}
          />
        </>
      )}
    </Stack>
  );
};
